/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppAnalyticsRouteImport } from './routes/_app.analytics'
import { Route as AppBannersRouteImport } from './routes/_app.banners'
import { Route as AppBlogRouteImport } from './routes/_app.blog'
import { Route as AppCatalogRouteImport } from './routes/_app.catalog'
import { Route as AppDeliveryRouteImport } from './routes/_app.delivery'
import { Route as AppMarketingRouteImport } from './routes/_app.marketing'
import { Route as AppMessagesRouteImport } from './routes/_app.messages'
import { Route as AppOrdersRouteImport } from './routes/_app.orders'
import { Route as AppPagesRouteImport } from './routes/_app.pages'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as AppSeoRouteImport } from './routes/_app.seo'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppUsersRouteImport } from './routes/_app.users'
import { Route as AppBannersSecretPagesRouteImport } from './routes/_app.banners_.secret-pages'
import { Route as AppCatalogAttributesRouteImport } from './routes/_app.catalog_.attributes'
import { Route as AppCatalogCategoriesRouteImport } from './routes/_app.catalog_.categories'
import { Route as AppCatalogCostGroupsRouteImport } from './routes/_app.catalog_.cost-groups'
import { Route as AppCatalogDictionariesRouteImport } from './routes/_app.catalog_.dictionaries'
import { Route as AppCatalogSkuCountersRouteImport } from './routes/_app.catalog_.sku-counters'
import { Route as AppCatalogAttributesAttributeIdRouteImport } from './routes/_app.catalog_.attributes_.$attributeId'
import { Route as AppCatalogAttributesNewRouteImport } from './routes/_app.catalog_.attributes_.new'
import { Route as AppCatalogCategoriesCategoryIdRouteImport } from './routes/_app.catalog_.categories_.$categoryId'
import { Route as AppCatalogCategoriesNewRouteImport } from './routes/_app.catalog_.categories_.new'
import { Route as AppCatalogDictionariesDictionaryIdRouteImport } from './routes/_app.catalog_.dictionaries_.$dictionaryId'
import { Route as AppCatalogProductsProductIdRouteImport } from './routes/_app.catalog_.products_.$productId'
import { Route as AppCatalogProductsNewRouteImport } from './routes/_app.catalog_.products_.new'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppBannersRoute = AppBannersRouteImport.update({
  id: '/banners',
  path: '/banners',
  getParentRoute: () => AppRoute,
} as any)
const AppBlogRoute = AppBlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogRoute = AppCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AppRoute,
} as any)
const AppDeliveryRoute = AppDeliveryRouteImport.update({
  id: '/delivery',
  path: '/delivery',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketingRoute = AppMarketingRouteImport.update({
  id: '/marketing',
  path: '/marketing',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppPagesRoute = AppPagesRouteImport.update({
  id: '/pages',
  path: '/pages',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppSeoRoute = AppSeoRouteImport.update({
  id: '/seo',
  path: '/seo',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppBannersSecretPagesRoute = AppBannersSecretPagesRouteImport.update({
  id: '/banners_/secret-pages',
  path: '/banners/secret-pages',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogAttributesRoute = AppCatalogAttributesRouteImport.update({
  id: '/catalog_/attributes',
  path: '/catalog/attributes',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogCategoriesRoute = AppCatalogCategoriesRouteImport.update({
  id: '/catalog_/categories',
  path: '/catalog/categories',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogCostGroupsRoute = AppCatalogCostGroupsRouteImport.update({
  id: '/catalog_/cost-groups',
  path: '/catalog/cost-groups',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogDictionariesRoute = AppCatalogDictionariesRouteImport.update({
  id: '/catalog_/dictionaries',
  path: '/catalog/dictionaries',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogSkuCountersRoute = AppCatalogSkuCountersRouteImport.update({
  id: '/catalog_/sku-counters',
  path: '/catalog/sku-counters',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogAttributesAttributeIdRoute =
  AppCatalogAttributesAttributeIdRouteImport.update({
    id: '/catalog_/attributes_/$attributeId',
    path: '/catalog/attributes/$attributeId',
    getParentRoute: () => AppRoute,
  } as any)
const AppCatalogAttributesNewRoute = AppCatalogAttributesNewRouteImport.update({
  id: '/catalog_/attributes_/new',
  path: '/catalog/attributes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogCategoriesCategoryIdRoute =
  AppCatalogCategoriesCategoryIdRouteImport.update({
    id: '/catalog_/categories_/$categoryId',
    path: '/catalog/categories/$categoryId',
    getParentRoute: () => AppRoute,
  } as any)
const AppCatalogCategoriesNewRoute = AppCatalogCategoriesNewRouteImport.update({
  id: '/catalog_/categories_/new',
  path: '/catalog/categories/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogDictionariesDictionaryIdRoute =
  AppCatalogDictionariesDictionaryIdRouteImport.update({
    id: '/catalog_/dictionaries_/$dictionaryId',
    path: '/catalog/dictionaries/$dictionaryId',
    getParentRoute: () => AppRoute,
  } as any)
const AppCatalogProductsProductIdRoute =
  AppCatalogProductsProductIdRouteImport.update({
    id: '/catalog_/products_/$productId',
    path: '/catalog/products/$productId',
    getParentRoute: () => AppRoute,
  } as any)
const AppCatalogProductsNewRoute = AppCatalogProductsNewRouteImport.update({
  id: '/catalog_/products_/new',
  path: '/catalog/products/new',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/analytics': typeof AppAnalyticsRoute
  '/banners': typeof AppBannersRoute
  '/blog': typeof AppBlogRoute
  '/catalog': typeof AppCatalogRoute
  '/delivery': typeof AppDeliveryRoute
  '/marketing': typeof AppMarketingRoute
  '/messages': typeof AppMessagesRoute
  '/orders': typeof AppOrdersRoute
  '/pages': typeof AppPagesRoute
  '/profile': typeof AppProfileRoute
  '/seo': typeof AppSeoRoute
  '/settings': typeof AppSettingsRoute
  '/users': typeof AppUsersRoute
  '/banners/secret-pages': typeof AppBannersSecretPagesRoute
  '/catalog/attributes': typeof AppCatalogAttributesRoute
  '/catalog/categories': typeof AppCatalogCategoriesRoute
  '/catalog/cost-groups': typeof AppCatalogCostGroupsRoute
  '/catalog/dictionaries': typeof AppCatalogDictionariesRoute
  '/catalog/sku-counters': typeof AppCatalogSkuCountersRoute
  '/catalog/attributes/$attributeId': typeof AppCatalogAttributesAttributeIdRoute
  '/catalog/attributes/new': typeof AppCatalogAttributesNewRoute
  '/catalog/categories/$categoryId': typeof AppCatalogCategoriesCategoryIdRoute
  '/catalog/categories/new': typeof AppCatalogCategoriesNewRoute
  '/catalog/dictionaries/$dictionaryId': typeof AppCatalogDictionariesDictionaryIdRoute
  '/catalog/products/$productId': typeof AppCatalogProductsProductIdRoute
  '/catalog/products/new': typeof AppCatalogProductsNewRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/analytics': typeof AppAnalyticsRoute
  '/banners': typeof AppBannersRoute
  '/blog': typeof AppBlogRoute
  '/catalog': typeof AppCatalogRoute
  '/delivery': typeof AppDeliveryRoute
  '/marketing': typeof AppMarketingRoute
  '/messages': typeof AppMessagesRoute
  '/orders': typeof AppOrdersRoute
  '/pages': typeof AppPagesRoute
  '/profile': typeof AppProfileRoute
  '/seo': typeof AppSeoRoute
  '/settings': typeof AppSettingsRoute
  '/users': typeof AppUsersRoute
  '/': typeof AppIndexRoute
  '/banners/secret-pages': typeof AppBannersSecretPagesRoute
  '/catalog/attributes': typeof AppCatalogAttributesRoute
  '/catalog/categories': typeof AppCatalogCategoriesRoute
  '/catalog/cost-groups': typeof AppCatalogCostGroupsRoute
  '/catalog/dictionaries': typeof AppCatalogDictionariesRoute
  '/catalog/sku-counters': typeof AppCatalogSkuCountersRoute
  '/catalog/attributes/$attributeId': typeof AppCatalogAttributesAttributeIdRoute
  '/catalog/attributes/new': typeof AppCatalogAttributesNewRoute
  '/catalog/categories/$categoryId': typeof AppCatalogCategoriesCategoryIdRoute
  '/catalog/categories/new': typeof AppCatalogCategoriesNewRoute
  '/catalog/dictionaries/$dictionaryId': typeof AppCatalogDictionariesDictionaryIdRoute
  '/catalog/products/$productId': typeof AppCatalogProductsProductIdRoute
  '/catalog/products/new': typeof AppCatalogProductsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/banners': typeof AppBannersRoute
  '/_app/blog': typeof AppBlogRoute
  '/_app/catalog': typeof AppCatalogRoute
  '/_app/delivery': typeof AppDeliveryRoute
  '/_app/marketing': typeof AppMarketingRoute
  '/_app/messages': typeof AppMessagesRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/pages': typeof AppPagesRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/seo': typeof AppSeoRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/users': typeof AppUsersRoute
  '/_app/': typeof AppIndexRoute
  '/_app/banners_/secret-pages': typeof AppBannersSecretPagesRoute
  '/_app/catalog_/attributes': typeof AppCatalogAttributesRoute
  '/_app/catalog_/categories': typeof AppCatalogCategoriesRoute
  '/_app/catalog_/cost-groups': typeof AppCatalogCostGroupsRoute
  '/_app/catalog_/dictionaries': typeof AppCatalogDictionariesRoute
  '/_app/catalog_/sku-counters': typeof AppCatalogSkuCountersRoute
  '/_app/catalog_/attributes_/$attributeId': typeof AppCatalogAttributesAttributeIdRoute
  '/_app/catalog_/attributes_/new': typeof AppCatalogAttributesNewRoute
  '/_app/catalog_/categories_/$categoryId': typeof AppCatalogCategoriesCategoryIdRoute
  '/_app/catalog_/categories_/new': typeof AppCatalogCategoriesNewRoute
  '/_app/catalog_/dictionaries_/$dictionaryId': typeof AppCatalogDictionariesDictionaryIdRoute
  '/_app/catalog_/products_/$productId': typeof AppCatalogProductsProductIdRoute
  '/_app/catalog_/products_/new': typeof AppCatalogProductsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/login'
    | '/analytics'
    | '/banners'
    | '/blog'
    | '/catalog'
    | '/delivery'
    | '/marketing'
    | '/messages'
    | '/orders'
    | '/pages'
    | '/profile'
    | '/seo'
    | '/settings'
    | '/users'
    | '/banners/secret-pages'
    | '/catalog/attributes'
    | '/catalog/categories'
    | '/catalog/cost-groups'
    | '/catalog/dictionaries'
    | '/catalog/sku-counters'
    | '/catalog/attributes/$attributeId'
    | '/catalog/attributes/new'
    | '/catalog/categories/$categoryId'
    | '/catalog/categories/new'
    | '/catalog/dictionaries/$dictionaryId'
    | '/catalog/products/$productId'
    | '/catalog/products/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/login'
    | '/analytics'
    | '/banners'
    | '/blog'
    | '/catalog'
    | '/delivery'
    | '/marketing'
    | '/messages'
    | '/orders'
    | '/pages'
    | '/profile'
    | '/seo'
    | '/settings'
    | '/users'
    | '/'
    | '/banners/secret-pages'
    | '/catalog/attributes'
    | '/catalog/categories'
    | '/catalog/cost-groups'
    | '/catalog/dictionaries'
    | '/catalog/sku-counters'
    | '/catalog/attributes/$attributeId'
    | '/catalog/attributes/new'
    | '/catalog/categories/$categoryId'
    | '/catalog/categories/new'
    | '/catalog/dictionaries/$dictionaryId'
    | '/catalog/products/$productId'
    | '/catalog/products/new'
  id:
    | '__root__'
    | '/_app'
    | '/change-password'
    | '/login'
    | '/_app/analytics'
    | '/_app/banners'
    | '/_app/blog'
    | '/_app/catalog'
    | '/_app/delivery'
    | '/_app/marketing'
    | '/_app/messages'
    | '/_app/orders'
    | '/_app/pages'
    | '/_app/profile'
    | '/_app/seo'
    | '/_app/settings'
    | '/_app/users'
    | '/_app/'
    | '/_app/banners_/secret-pages'
    | '/_app/catalog_/attributes'
    | '/_app/catalog_/categories'
    | '/_app/catalog_/cost-groups'
    | '/_app/catalog_/dictionaries'
    | '/_app/catalog_/sku-counters'
    | '/_app/catalog_/attributes_/$attributeId'
    | '/_app/catalog_/attributes_/new'
    | '/_app/catalog_/categories_/$categoryId'
    | '/_app/catalog_/categories_/new'
    | '/_app/catalog_/dictionaries_/$dictionaryId'
    | '/_app/catalog_/products_/$productId'
    | '/_app/catalog_/products_/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/banners': {
      id: '/_app/banners'
      path: '/banners'
      fullPath: '/banners'
      preLoaderRoute: typeof AppBannersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/blog': {
      id: '/_app/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof AppBlogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog': {
      id: '/_app/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof AppCatalogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/delivery': {
      id: '/_app/delivery'
      path: '/delivery'
      fullPath: '/delivery'
      preLoaderRoute: typeof AppDeliveryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing': {
      id: '/_app/marketing'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof AppMarketingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pages': {
      id: '/_app/pages'
      path: '/pages'
      fullPath: '/pages'
      preLoaderRoute: typeof AppPagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seo': {
      id: '/_app/seo'
      path: '/seo'
      fullPath: '/seo'
      preLoaderRoute: typeof AppSeoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/banners_/secret-pages': {
      id: '/_app/banners_/secret-pages'
      path: '/banners/secret-pages'
      fullPath: '/banners/secret-pages'
      preLoaderRoute: typeof AppBannersSecretPagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/attributes': {
      id: '/_app/catalog_/attributes'
      path: '/catalog/attributes'
      fullPath: '/catalog/attributes'
      preLoaderRoute: typeof AppCatalogAttributesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/categories': {
      id: '/_app/catalog_/categories'
      path: '/catalog/categories'
      fullPath: '/catalog/categories'
      preLoaderRoute: typeof AppCatalogCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/cost-groups': {
      id: '/_app/catalog_/cost-groups'
      path: '/catalog/cost-groups'
      fullPath: '/catalog/cost-groups'
      preLoaderRoute: typeof AppCatalogCostGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/dictionaries': {
      id: '/_app/catalog_/dictionaries'
      path: '/catalog/dictionaries'
      fullPath: '/catalog/dictionaries'
      preLoaderRoute: typeof AppCatalogDictionariesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/sku-counters': {
      id: '/_app/catalog_/sku-counters'
      path: '/catalog/sku-counters'
      fullPath: '/catalog/sku-counters'
      preLoaderRoute: typeof AppCatalogSkuCountersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/attributes_/$attributeId': {
      id: '/_app/catalog_/attributes_/$attributeId'
      path: '/catalog/attributes/$attributeId'
      fullPath: '/catalog/attributes/$attributeId'
      preLoaderRoute: typeof AppCatalogAttributesAttributeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/attributes_/new': {
      id: '/_app/catalog_/attributes_/new'
      path: '/catalog/attributes/new'
      fullPath: '/catalog/attributes/new'
      preLoaderRoute: typeof AppCatalogAttributesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/categories_/$categoryId': {
      id: '/_app/catalog_/categories_/$categoryId'
      path: '/catalog/categories/$categoryId'
      fullPath: '/catalog/categories/$categoryId'
      preLoaderRoute: typeof AppCatalogCategoriesCategoryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/categories_/new': {
      id: '/_app/catalog_/categories_/new'
      path: '/catalog/categories/new'
      fullPath: '/catalog/categories/new'
      preLoaderRoute: typeof AppCatalogCategoriesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/dictionaries_/$dictionaryId': {
      id: '/_app/catalog_/dictionaries_/$dictionaryId'
      path: '/catalog/dictionaries/$dictionaryId'
      fullPath: '/catalog/dictionaries/$dictionaryId'
      preLoaderRoute: typeof AppCatalogDictionariesDictionaryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/products_/$productId': {
      id: '/_app/catalog_/products_/$productId'
      path: '/catalog/products/$productId'
      fullPath: '/catalog/products/$productId'
      preLoaderRoute: typeof AppCatalogProductsProductIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog_/products_/new': {
      id: '/_app/catalog_/products_/new'
      path: '/catalog/products/new'
      fullPath: '/catalog/products/new'
      preLoaderRoute: typeof AppCatalogProductsNewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppBannersRoute: typeof AppBannersRoute
  AppBlogRoute: typeof AppBlogRoute
  AppCatalogRoute: typeof AppCatalogRoute
  AppDeliveryRoute: typeof AppDeliveryRoute
  AppMarketingRoute: typeof AppMarketingRoute
  AppMessagesRoute: typeof AppMessagesRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppPagesRoute: typeof AppPagesRoute
  AppProfileRoute: typeof AppProfileRoute
  AppSeoRoute: typeof AppSeoRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppBannersSecretPagesRoute: typeof AppBannersSecretPagesRoute
  AppCatalogAttributesRoute: typeof AppCatalogAttributesRoute
  AppCatalogCategoriesRoute: typeof AppCatalogCategoriesRoute
  AppCatalogCostGroupsRoute: typeof AppCatalogCostGroupsRoute
  AppCatalogDictionariesRoute: typeof AppCatalogDictionariesRoute
  AppCatalogSkuCountersRoute: typeof AppCatalogSkuCountersRoute
  AppCatalogAttributesAttributeIdRoute: typeof AppCatalogAttributesAttributeIdRoute
  AppCatalogAttributesNewRoute: typeof AppCatalogAttributesNewRoute
  AppCatalogCategoriesCategoryIdRoute: typeof AppCatalogCategoriesCategoryIdRoute
  AppCatalogCategoriesNewRoute: typeof AppCatalogCategoriesNewRoute
  AppCatalogDictionariesDictionaryIdRoute: typeof AppCatalogDictionariesDictionaryIdRoute
  AppCatalogProductsProductIdRoute: typeof AppCatalogProductsProductIdRoute
  AppCatalogProductsNewRoute: typeof AppCatalogProductsNewRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppBannersRoute: AppBannersRoute,
  AppBlogRoute: AppBlogRoute,
  AppCatalogRoute: AppCatalogRoute,
  AppDeliveryRoute: AppDeliveryRoute,
  AppMarketingRoute: AppMarketingRoute,
  AppMessagesRoute: AppMessagesRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppPagesRoute: AppPagesRoute,
  AppProfileRoute: AppProfileRoute,
  AppSeoRoute: AppSeoRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppBannersSecretPagesRoute: AppBannersSecretPagesRoute,
  AppCatalogAttributesRoute: AppCatalogAttributesRoute,
  AppCatalogCategoriesRoute: AppCatalogCategoriesRoute,
  AppCatalogCostGroupsRoute: AppCatalogCostGroupsRoute,
  AppCatalogDictionariesRoute: AppCatalogDictionariesRoute,
  AppCatalogSkuCountersRoute: AppCatalogSkuCountersRoute,
  AppCatalogAttributesAttributeIdRoute: AppCatalogAttributesAttributeIdRoute,
  AppCatalogAttributesNewRoute: AppCatalogAttributesNewRoute,
  AppCatalogCategoriesCategoryIdRoute: AppCatalogCategoriesCategoryIdRoute,
  AppCatalogCategoriesNewRoute: AppCatalogCategoriesNewRoute,
  AppCatalogDictionariesDictionaryIdRoute:
    AppCatalogDictionariesDictionaryIdRoute,
  AppCatalogProductsProductIdRoute: AppCatalogProductsProductIdRoute,
  AppCatalogProductsNewRoute: AppCatalogProductsNewRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
